import React from 'react';
import { Modal } from '../common/Modal';

interface TermsModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({
  isOpen,
  onAccept,
  onDecline
}) => {
  const renderFooter = () => (
    <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
      <button
        onClick={onDecline}
        className="w-full sm:w-auto px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-red-600 dark:text-red-400 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700"
      >
        Ablehnen
      </button>
      <button
        onClick={onAccept}
        className="w-full sm:w-auto px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
      >
        Akzeptieren
      </button>
    </div>
  );

  return (<Modal
  isOpen={isOpen}
  onClose={() => {}}
  title="Willkommen bei Stallmanagement"
  footer={renderFooter()}
  size="lg"
  showClose={false}
>
  <div className="prose dark:prose-invert max-w-none">
    <h3>Herzlich Willkommen in der Equisuite vom Reitstall Beckmann!</h3>

    <p>
      Bevor Sie starten, bitten wir Sie, die folgenden Nutzungsbedingungen zu lesen und zu akzeptieren. Sie helfen uns dabei, einen reibungslosen Ablauf für alle zu gewährleisten.
    </p>

    <h4>1. Allgemeine Bestimmungen</h4>
    <p>
      Mit der Nutzung dieser Software erklären Sie sich mit den folgenden Bedingungen einverstanden.
    </p>

    <h4>2. Datenschutz</h4>
    <p>
      Ihre persönlichen Daten sind bei uns sicher. Alle erhobenen Informationen werden vertraulich behandelt und nur für die vorgesehenen Zwecke verwendet.
    </p>

    <h4>3. Nutzungsregeln</h4>
    <ul>
      <li>Keine missbräuchliche Nutzung der Plattform</li>
      <li>Wahrheitsgemäße Angaben bei der Registrierung und Nutzung</li>
      <li>Die Weitergabe von Accountdaten ist nicht gestattet</li>
      <li>Die Nutzung der Halle ist ausschließlich für das Pferd erlaubt, das für den jeweiligen Slot reserviert wurde. Ist ein Slot nicht gebucht, darf die Halle frei genutzt werden</li>
      <li>Falls Sie eine Buchung nicht wahrnehmen können, bitten wir Sie, diese möglichst frühzeitig zu stornieren</li>
    </ul>
 
    <div className="bg-yellow-50 dark:bg-yellow-900/50 p-4 rounded-lg mt-4">
      <p className="text-sm text-yellow-800 dark:text-yellow-200">
        <strong>Bitte beachten Sie:</strong> Wenn Sie diese Nutzungsbedingungen nicht akzeptieren, können Sie die Plattform leider nicht nutzen.
      </p>
    </div>
  </div>
</Modal>

  );
};
